﻿import React from "react";
import CallTrackApi from "../Activity_Track/CallTrackApi";
function Emicalculator() {
    function iframe() {
        return {
            __html: '<iframe src="emi-calculator.html" title="EMI Calculator" width="100%" height="650px" style="border:0; overflow:hidden"></iframe>'
        }
    }
  CallTrackApi("EMI Calculator",window.location.href);

    return (
        <>

            <div>
                <div dangerouslySetInnerHTML={iframe()} />
            </div>    
        </>
    );
}
export default Emicalculator;